import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "397",
  "slug": "best-youtube-channels-learning-geography",
  "title": "The Best YouTube Channels for Learning Geography in 2026",
  "excerpt": "Whether you want deep geopolitics or fast map facts, these YouTube channels make geography genuinely fun to learn. Here is where to start.",
  "date": "2026-06-10",
  "category": "Community",
  "image": "https://images.unsplash.com/photo-1771797628441-20bc5804f48d?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHx3b3JsZCUyMGdsb2JlJTIwZGVza3xlbnwxfDB8fHwxNzgxMDc5MjE5fDA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "3 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Geography might be the subject that has benefited most from YouTube. Maps, satellite imagery, and animation are tailor-made for video, and a wave of creators has turned 'why is this border here' and 'how does this country actually work' into binge-worthy viewing. Whether you want serious analysis or quick map trivia, here are the channels worth subscribing to."
    },
    {
      "type": "heading",
      "text": "For Deep Dives on Why the World Works"
    },
    {
      "type": "paragraph",
      "text": "RealLifeLore is the gateway channel for many geography fans, taking big questions like why a region is so contested or so empty and answering them with clear maps and steady narration. Atlas Pro goes deeper into physical geography and climate, explaining biomes, ocean currents, and landforms with genuine scientific care. Wendover Productions zooms out to the systems layer, unpacking the logistics, economics, and infrastructure that explain why the world is arranged the way it is."
    },
    {
      "type": "heading",
      "text": "For Country-by-Country Facts"
    },
    {
      "type": "paragraph",
      "text": "Geography Now is working through every country on Earth in alphabetical order, covering each one's physical features, politics, and friendships with its neighbours in an energetic, slightly chaotic format. It is the closest thing to a fun encyclopaedia of the world, and it is brilliant for filling in the gaps for countries you know almost nothing about."
    },
    {
      "type": "heading",
      "text": "For Maps, Wit, and Trivia"
    },
    {
      "type": "paragraph",
      "text": "Map Men, from British comedians Jay Foreman and Mark Cooper-Jones, is fast, funny, and surprisingly educational, tackling oddities like why time zones are a mess or how borders end up in strange places. Half as Interesting delivers bite-sized geographic and logistical curiosities, and CGP Grey's occasional geography videos, such as his famous explainer on the United Kingdom, are models of clarity."
    },
    {
      "type": "heading",
      "text": "For Watching the Skills in Action"
    },
    {
      "type": "paragraph",
      "text": "If you want to see geographic knowledge applied at speed, GeoWizard and Rainbolt are essential. Rainbolt's uncanny ability to identify a location from a single roadside photo is part entertainment, part masterclass in reading visual clues, while GeoWizard's straight-line missions across countries turn raw map skills into genuine adventure. Watching them is the fastest way to learn what details actually give a place away."
    },
    {
      "type": "list",
      "items": [
        "RealLifeLore, Atlas Pro, Wendover Productions, for in-depth explainers",
        "Geography Now, for a tour of every country",
        "Map Men, Half as Interesting, CGP Grey, for wit and quick facts",
        "GeoWizard, Rainbolt, for location-finding skills in action"
      ]
    },
    {
      "type": "paragraph",
      "text": "After watching an explanation of a landform, find another example on a map. Try identifying the feature before checking the labels, then compare it with the one in the video."
    }
  ]
};
